import { render, staticRenderFns } from "./IhbarnameTalepEvrakForm.vue?vue&type=template&id=93f7219a&scoped=true"
import script from "./IhbarnameTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./IhbarnameTalepEvrakForm.vue?vue&type=script&lang=ts"
import style0 from "./IhbarnameTalepEvrakForm.vue?vue&type=style&index=0&id=93f7219a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f7219a",
  null
  
)

export default component.exports